import { Component, Knobs, Story } from './DocTypes';

const knobs: Knobs = {
  accent: {
    default: 'white',
    editor: 'dropdown',
    editorOptions: ['navy', 'white'],
  },
};

const HierarchicalStory: Story = {
  title: 'Hierarchical',
  description: 'A navigation bar with a hierarchical panel',
  coreComponent_v3: {
    html: `<tag3-side-nav collapsable{{...knobs}}>
  <tag3-side-nav-header>SUPER APP</tag3-side-nav-header>
  <tag3-side-nav-body>
    <tag3-side-nav-item name="sales" icon="LineChartSolid" text="Sales" collapsable>
      <div slot="items">
        <tag3-side-nav-item icon="Student" text="Orders" indent="1" collapsable>
          <div slot="items">
            <tag3-side-nav-item name="unpaidOrders" text="Unpaid" indent="2"></tag3-side-nav-item>
            <tag3-side-nav-item name="awaitingShipment" text="Awaiting Shipment" indent="2" collapsable>
              <div slot="items">
                <tag3-side-nav-item name="today" text="Today" indent="3" collapsable>
                  <div slot="items">
                    <tag3-side-nav-item name="am" text="AM" indent="4"></tag3-side-nav-item>
                    <tag3-side-nav-item name="pm" text="PM" indent="4"></tag3-side-nav-item>
                  </div>
                </tag3-side-nav-item>
                <tag3-side-nav-item name="tomorrow" text="Tomorrow" indent="3"></tag3-side-nav-item>
              </div>
            </tag3-side-nav-item>
            <tag3-side-nav-item name="historic" text="Historic" indent="2"></tag3-side-nav-item>
          </div>
        </tag3-side-nav-item>
        <tag3-side-nav-item name="salesBrochures" icon="DocImage" text="Sales Brochures" indent="1"></tag3-side-nav-item>
        <tag3-side-nav-item name="reports" icon="DocContract" text="Internal Reports" indent="1"></tag3-side-nav-item>
      </div>
    </tag3-side-nav-item>
    <tag3-side-nav-item icon="Pound1" text="Purchasing" collapsable>
      <div slot="items">
        <tag3-side-nav-item name="unpaid" icon="CashBook" text="Unpaid Invoices" indent="1"></tag3-side-nav-item>
        <tag3-side-nav-item icon="Student" text="Training Materials" indent="1" collapsable>
          <div slot="items">
            <tag3-side-nav-item name="certification" text="Certification" indent="2"></tag3-side-nav-item>
          </div>
        </tag3-side-nav-item>
        <tag3-side-nav-item name="salesBrochures" icon="DocImage" text="Sales Brochures" indent="1"></tag3-side-nav-item>
        <tag3-side-nav-item name="reports" icon="DocContract" text="Internal Reports" indent="1"></tag3-side-nav-item>
      </div>
    </tag3-side-nav-item>
    <tag3-side-nav-item name="stock" icon="Stock" text="Stock"></tag3-side-nav-item>
  </tag3-side-nav-body>
</tag3-side-nav>`,
    knobs: knobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3SideNav collapsable{{...knobs}}>
    <Tag3SideNavHeader>SUPER APP</Tag3SideNavHeader>
    <Tag3SideNavBody>
      <Tag3SideNavItem name="sales" icon="LineChartSolid" text="Sales" collapsable>
        <div slot="items">
          <Tag3SideNavItem icon="Student" text="Orders" indent={1} collapsable>
            <div slot="items">
              <Tag3SideNavItem name="unpaidOrders" text="Unpaid" indent={2}></Tag3SideNavItem>
              <Tag3SideNavItem name="awaitingShipment" text="Awaiting Shipment" indent={2} collapsable>
                <div slot="items">
                  <Tag3SideNavItem name="today" text="Today" indent={3} collapsable>
                    <div slot="items">
                      <Tag3SideNavItem name="am" text="AM" indent={4}></Tag3SideNavItem>
                      <Tag3SideNavItem name="pm" text="PM" indent={4}></Tag3SideNavItem>
                    </div>
                  </Tag3SideNavItem>
                  <Tag3SideNavItem name="tomorrow" text="Tomorrow" indent={3}></Tag3SideNavItem>
                </div>
              </Tag3SideNavItem>
              <Tag3SideNavItem name="historic" text="Historic" indent={2}></Tag3SideNavItem>
            </div>
          </Tag3SideNavItem>
          <Tag3SideNavItem name="salesBrochures" icon="DocImage" text="Sales Brochures" indent={1}></Tag3SideNavItem>
          <Tag3SideNavItem name="reports" icon="DocContract" text="Internal Reports" indent={1}></Tag3SideNavItem>
        </div>
      </Tag3SideNavItem>
      <Tag3SideNavItem icon="Pound1" text="Purchasing" collapsable>
        <div slot="items">
          <Tag3SideNavItem name="unpaid" icon="CashBook" text="Unpaid Invoices" indent={1}></Tag3SideNavItem>
          <Tag3SideNavItem icon="Student" text="Training Materials" indent={1} collapsable>
            <div slot="items">
              <Tag3SideNavItem name="certification" text="Certification" indent={2}></Tag3SideNavItem>
            </div>
          </Tag3SideNavItem>
          <Tag3SideNavItem name="salesBrochures" icon="DocImage" text="Sales Brochures" indent={1}></Tag3SideNavItem>
          <Tag3SideNavItem name="reports" icon="DocContract" text="Internal Reports" indent={1}></Tag3SideNavItem>
        </div>
      </Tag3SideNavItem>
      <Tag3SideNavItem name="stock" icon="Stock" text="Stock"></Tag3SideNavItem>
    </Tag3SideNavBody>
  </Tag3SideNav>`,
    knobs: knobs,
  },
};

const SingleLevelStory: Story = {
  title: 'Single level',
  description: 'A single level navigation bar',
  coreComponent_v3: {
    html: `<tag3-side-nav{{...knobs}}>
  <tag3-side-nav-header>
    MY SIMPLE APP
  </tag3-side-nav-header>
  <tag3-side-nav-body>
    <tag3-side-nav-item name="sales" icon="LineChartSolid" text="Sales">
    </tag3-side-nav-item>
    <tag3-side-nav-item name="purchasing" icon="Pound1" text="Purchasing">
    </tag3-side-nav-item>
    <tag3-side-nav-item name="stock" icon="Stock" text="Stock">
    </tag3-side-nav-item>
  </tag3-side-nav-body>
</tag3-side-nav>`,
    knobs: knobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3SideNav{{...knobs}}>
    <Tag3SideNavHeader>
      MY SIMPLE APP
    </Tag3SideNavHeader>
    <Tag3SideNavBody>
      <Tag3SideNavItem name="sales" icon="LineChartSolid" text="Sales">
      </Tag3SideNavItem>
      <Tag3SideNavItem name="purchasing" icon="Pound1" text="Purchasing">
      </Tag3SideNavItem>
      <Tag3SideNavItem name="stock" icon="Stock" text="Stock">
      </Tag3SideNavItem>
    </Tag3SideNavBody>
  </Tag3SideNav>`,
    knobs: knobs,
  },
};

const CollapsablePanelStory: Story = {
  title: 'Collapsable Panel',
  description: 'A navigation bar with collapsable panels',
  coreComponent_v3: {
    html: `<tag3-side-nav accent="white" collapsable>   
  <tag3-side-nav-header>
    <tag3-icon-svg icon="Clipboard"></tag3-icon-svg>
    <span style="margin-left: 5px;">My Console</span>
  </tag3-side-nav-header>
  <tag3-side-nav-body style="height: 600px; display: flex; flex-direction: column;">
    <tag3-side-nav-panel>
      <div slot="nav-expanded">
        <tag3-input placeholder="Search ..." style="width: 240px; margin: 0 10px;" input-style='{"background-color": "#B1B8BF"}'></tag3-input>
        <div style="margin-top:10px;">
          <tag3-side-nav-item name="home" icon="Home" text="Home"></tag3-side-nav-item>
          <tag3-side-nav-item name="entities" icon="Books" text="Entities"></tag3-side-nav-item>
        </div>
      </div>
      <div slot="nav-collapsed">
        <tag3-side-nav-item name="home" icon="Home" text="Home"></tag3-side-nav-item>
        <tag3-side-nav-item name="entities" icon="Books" text="Entities"></tag3-side-nav-item>
      </div>
    </tag3-side-nav-panel>
    <tag3-side-nav-panel icon="Pin" heading="Pinned" collapsable>
      <div slot="nav-expanded">
        <tag3-side-nav-item name="b9ab0bf8-cc31-4835-b885-fd335781793c">
          <div slot="nav-expanded" style="display:flex; align-items:center;">
            <tag3-avatar src="https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260" size="30px"></tag3-avatar>
            <span style="margin-left: 5px;">Jesse Norris</span>
          </div>
        </tag3-side-nav-item>
        <tag3-side-nav-item name="9a63282b-94ed-49d7-b622-96ea0e084b7d">
          <div slot="nav-expanded" style="display:flex; align-items:center;">
            <tag3-avatar src="https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260" size="30px"></tag3-avatar>
            <span style="margin-left: 5px;">Sue Maguire</span>
          </div>
        </tag3-side-nav-item>
      </div>
    </tag3-side-nav-panel>
    <tag3-side-nav-panel icon="TickThin" heading="Top Rated" collapsable>
      <div slot="nav-expanded">
        <tag3-side-nav-item name="3dda56c5-5933-49d4-9918-a20cfd9f17b8">
          <div slot="nav-expanded" style="display:flex; align-items:center;">
            <tag3-avatar src="https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260" size="30px"></tag3-avatar>
            <span style="margin-left: 5px;">Derik Kane</span>
          </div>
        </tag3-side-nav-item>
      </div>
    </tag3-side-nav-panel>
    <tag3-side-nav-panel style="margin-top: auto; border-top: 1px solid #e7e7e7;">
      <div slot="nav-expanded">
        <tag3-side-nav-item name="admin" icon="Settings" text="Settings"></tag3-side-nav-item>
      </div>
      <div slot="nav-collapsed">
        <tag3-side-nav-item name="admin" icon="Settings" text="Settings"></tag3-side-nav-item>
      </div>
    </tag3-side-nav-panel>
  </tag3-side-nav-body>
</tag3-side-nav>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3SideNav accent="white" collapsable>   
  <Tag3SideNavHeader>
    <Tag3IconSvg icon="Clipboard"></Tag3IconSvg>
    <span style={{marginLeft: "5px"}}>My Console</span>
  </Tag3SideNavHeader>
  <Tag3SideNavBody style={{height: "600px", display: "flex", flexDirection: "column"}}>
    <Tag3SideNavPanel>
      <div slot="nav-expanded">
        <Tag3Input placeholder="Search ..." style={{width: "240px", margin: "0 10px"}} inputStyle={{backgroundColor: "#B1B8BF"}} />
        <div style={{marginTop: "10px"}}>
          <Tag3SideNavItem name="home" icon="Home" text="Home" />
          <Tag3SideNavItem name="entities" icon="Books" text="Entities" />
        </div>
      </div>
      <div slot="nav-collapsed">
        <Tag3SideNavItem name="home" icon="Home" text="Home" />
        <Tag3SideNavItem name="entities" icon="Books" text="Entities" />
      </div>
    </Tag3SideNavPanel>
    <Tag3SideNavPanel icon="Pin" heading="Pinned" collapsable>
      <div slot="nav-expanded">
        <Tag3SideNavItem name="b9ab0bf8-cc31-4835-b885-fd335781793c">
          <div slot="nav-expanded" style={{display: "flex", alignItems: "center"}}>
            <Tag3Avatar src="https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260" size="30px" />
            <span style={{marginLeft: "5px"}}>Jesse Norris</span>
          </div>
        </Tag3SideNavItem>
        <Tag3SideNavItem name="9a63282b-94ed-49d7-b622-96ea0e084b7d">
          <div slot="nav-expanded" style={{display: "flex", alignItems: "center"}}>
            <Tag3Avatar src="https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260" size="30px" />
            <span style={{marginLeft: "5px"}}>Sue Maguire</span>
          </div>
        </Tag3SideNavItem>
      </div>
    </Tag3SideNavPanel>
    <Tag3SideNavPanel icon="TickThin" heading="Top Rated" collapsable>
      <div slot="nav-expanded">
        <Tag3SideNavItem name="3dda56c5-5933-49d4-9918-a20cfd9f17b8">
          <div slot="nav-expanded" style={{display: "flex", alignItems: "center"}}>
            <Tag3Avatar src="https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260" size="30px" />
            <span style={{marginLeft: "5px"}}>Derik Kane</span>
          </div>
        </Tag3SideNavItem>
      </div>
    </Tag3SideNavPanel>
    <Tag3SideNavPanel style={{marginTop: "auto", borderTop: "1px solid #e7e7e7"}}>
      <div slot="nav-expanded">
        <Tag3SideNavItem name="admin" icon="Settings" text="Settings"></Tag3SideNavItem>
      </div>
    </Tag3SideNavPanel>
  </Tag3SideNavBody>
</Tag3SideNav>`,
  },
};

const CustomHeaderStory: Story = {
  title: 'Custom header',
  description: 'A navigation bar with a custom header',
  coreComponent_v3: {
    html: `<tag3-side-nav>
  <tag3-side-nav-header>
    <tag3-icon-svg icon="Badge" accent="navy"></tag3-icon-svg>
    <span style="margin-left: 5px;">SUPER APP</span>
  </tag3-side-nav-header>
  <tag3-side-nav-body>
    <tag3-side-nav-item name="sales" icon="LineChartSolid" text="Sales"></tag3-side-nav-item>
  </tag3-side-nav-body>
</tag3-side-nav>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3SideNav>
    <Tag3SideNavHeader>
      <Tag3IconSvg icon="Badge" accent="navy"></Tag3IconSvg>
      <span style={{marginLeft: "5px"}}>SUPER APP</span>
    </Tag3SideNavHeader>
    <Tag3SideNavBody>
      <Tag3SideNavItem name="sales" icon="LineChartSolid" text="Sales"></Tag3SideNavItem>
    </Tag3SideNavBody>
  </Tag3SideNav>`,
  },
};

const CustomItemsStory: Story = {
  title: 'Custom items',
  description: 'A navigation bar with custom items',
  coreComponent_v3: {
    html: `<tag3-side-nav collapsable>
  <tag3-side-nav-header></tag3-side-nav-header>
  <tag3-side-nav-body>
    <tag3-side-nav-item name="sales" collapsable>
      <div slot="nav-expanded" style="display:flex; align-items: center;">
        <tag3-icon-svg icon="LineChartSolid" accent="porcelain"></tag3-icon-svg>
        <span style="margin-left: 5px;">Sales Orders</span>
        <tag3-badge value="4" accent="dolphinblue" size="small" style="margin-left: auto; margin-right: 3px;"></tag3-badge>
      </div>
      <div slot="nav-collapsed" style="display:flex; align-items: center;">
        <tag3-icon-svg icon="LineChartSolid" accent="porcelain"></tag3-icon-svg>
      </div>
      <div slot="items">
        <tag3-side-nav-item name="today" text="Today" indent="1"></tag3-side-nav-item>
      </div>
    </tag3-side-nav-item>
    <tag3-side-nav-item name="documents">
      <div slot="nav-expanded" style="display:flex; align-items: center; width: 100%;">
        <tag3-icon-svg icon="Doc2" accent="porcelain"></tag3-icon-svg>
        <span style="margin-left: 5px;">Documents</span>
        <tag3-badge value="15" accent="dolphinblue" size="small" style="margin-left: auto; margin-right: 17px;"></tag3-badge>
      </div>
      <div slot="nav-collapsed" style="display:flex; align-items: center; width: 100%;">
        <tag3-icon-svg icon="Doc2" accent="porcelain"></tag3-icon-svg>
      </div>
    </tag3-side-nav-item>
  </tag3-side-nav-body>
</tag3-side-nav>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3SideNav collapsable>
  <Tag3SideNavHeader></Tag3SideNavHeader>
  <Tag3SideNavBody>
    <Tag3SideNavItem name="sales" collapsable>
      <div slot="nav-expanded" style={{display:"flex", alignItems: "center"}}>
        <Tag3IconSvg icon="LineChartSolid" accent="porcelain"></Tag3IconSvg>
        <span style={{marginLeft: "5px"}}>Sales Orders</span>
        <Tag3Badge value="4" accent="dolphinblue" size="small" style={{marginLeft: "auto",marginRight: "3px"}}></Tag3Badge>
      </div>
      <div slot="nav-collapsed" style={{display:"flex", alignItems: "center"}}>
        <Tag3IconSvg icon="LineChartSolid" accent="porcelain"></Tag3IconSvg>
      </div>
      <div slot="items">
        <Tag3SideNavItem name="today" text="Today" indent={1}></Tag3SideNavItem>
      </div>
    </Tag3SideNavItem>
    <Tag3SideNavItem name="documents">
      <div slot="nav-expanded" style={{display:"flex", alignItems: "center", width: "100%"}}>
        <Tag3IconSvg icon="Doc2" accent="porcelain"></Tag3IconSvg>
        <span style={{marginLeft: "5px"}}>Documents</span>
        <Tag3Badge value="15" accent="dolphinblue" size="small" style={{marginLeft: "auto", marginRight: "17px"}}></Tag3Badge>
      </div>
      <div slot="nav-collapsed" style={{display:"flex", alignItems: "center", width: "100%"}}>
        <Tag3IconSvg icon="Doc2" accent="porcelain"></Tag3IconSvg>
      </div>
    </Tag3SideNavItem>
  </Tag3SideNavBody>
</Tag3SideNav>`,
  },
};

const CustomPanelStory: Story = {
  title: 'Custom panel',
  description: 'A navigation bar with a custom panel',
  coreComponent_v3: {
    html: `<tag3-side-nav collapsable>
  <tag3-side-nav-header></tag3-side-nav-header>
  <tag3-side-nav-body>
    <tag3-side-nav-panel>
      <div slot="heading" style="display:flex; align-items:center;">
        <tag3-icon-svg icon="UserCasual1" accent="porcelain" size="14"></tag3-icon-svg>
        <span style="margin-left:3px;">CURRENT USER</span>
      </div>
      <div slot="nav-expanded" style="display: flex; align-items: center; padding: 10px 0px;">
        <tag3-avatar src="https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260"></tag3-avatar>
        <div style="margin-left: 10px;">
          <div style="font-size: 20px;color: #d7d9df;">Jason Long</div>
          <div style="font-size: 10px;color: #a3a4ac; font-weight: 700;">ADMIN</div>
        </div>
      </div>
      <div slot="nav-collapsed" style="display: flex; align-items: center; justify-content: center; padding: 10px 0px;">
        <tag3-avatar src="https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260"></tag3-avatar>
      </div>
    </tag3-side-nav-panel>
    <tag3-side-nav-panel>
      <div slot="nav-expanded">
        <tag3-side-nav-item name="sales" icon="LineChartSolid" text="Sales"></tag3-side-nav-item>
        <tag3-side-nav-item icon="Pound1" text="Purchasing"></tag3-side-nav-item>
        <tag3-side-nav-item name="stock" icon="Stock" text="Stock"></tag3-side-nav-item>
      </div>
      <div slot="nav-collapsed">
        <tag3-side-nav-item name="sales" icon="LineChartSolid" text="Sales"></tag3-side-nav-item>
        <tag3-side-nav-item icon="Pound1" text="Purchasing"></tag3-side-nav-item>
        <tag3-side-nav-item name="stock" icon="Stock" text="Stock"></tag3-side-nav-item>
      </div>
    </tag3-side-nav-panel>
  </tag3-side-nav-body>
</tag3-side-nav>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3SideNav collapsable>
  <Tag3SideNavHeader />
  <Tag3SideNavBody>
    <Tag3SideNavPanel>
      <div slot="heading" style={{display: "flex", alignItems: "center"}}>
        <Tag3IconSvg icon="UserCasual1" accent="porcelain" size="14" />
        <span style={{marginLeft: "3px"}}>CURRENT USER</span>
      </div>
      <div slot="nav-expanded" style={{display: "flex", alignItems: "center", padding: "10px 10px 10px 18px"}}>
        <Tag3Avatar src="https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260"></Tag3Avatar>
        <div style={{marginLeft: "10px"}}>
          <div style={{fontSize: "20px", color: "#d7d9df"}}>Jason Long</div>
          <div style={{fontSize: "10px", color: "#a3a4ac", fontWeight: "700"}}>ADMIN</div>
        </div>
      </div>
      <div slot="nav-collapsed" style={{display: "flex", alignItems: "center", justifyContent: "center", padding: "10px 0px"}}>
        <Tag3Avatar src="https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260"></Tag3Avatar>
      </div>
    </Tag3SideNavPanel>
    <Tag3SideNavPanel>
      <Tag3SideNavItem name="sales" icon="LineChartSolid" text="Sales"></Tag3SideNavItem>
      <Tag3SideNavItem icon="Pound1" text="Purchasing"></Tag3SideNavItem>
      <Tag3SideNavItem name="stock" icon="Stock" text="Stock"></Tag3SideNavItem>
    </Tag3SideNavPanel>
  </Tag3SideNavBody>
</Tag3SideNav>`,
  },
};

const SelectedItemStory: Story = {
  title: 'Selected item',
  description: 'A navigation bar with the selected item set',
  coreComponent_v3: {
    html: `<tag3-side-nav selected-item="stock">
  <tag3-side-nav-header>
    MY SIMPLE APP
  </tag3-side-nav-header>
  <tag3-side-nav-body>
    <tag3-side-nav-item name="sales" icon="LineChartSolid" text="Sales">
    </tag3-side-nav-item>
    <tag3-side-nav-item name="purchasing" icon="Pound1" text="Purchasing">
    </tag3-side-nav-item>
    <tag3-side-nav-item name="stock" icon="Stock" text="Stock">
    </tag3-side-nav-item>
  </tag3-side-nav-body>
</tag3-side-nav>`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3SideNav selectedItem="stock">
    <Tag3SideNavHeader>
      MY SIMPLE APP
    </Tag3SideNavHeader>
    <Tag3SideNavBody>
      <Tag3SideNavItem name="sales" icon="LineChartSolid" text="Sales">
      </Tag3SideNavItem>
      <Tag3SideNavItem name="purchasing" icon="Pound1" text="Purchasing">
      </Tag3SideNavItem>
      <Tag3SideNavItem name="stock" icon="Stock" text="Stock">
      </Tag3SideNavItem>
    </Tag3SideNavBody>
  </Tag3SideNav>`,
  },
};

const DynamicItemsStory: Story = {
  title: 'Dynamic items',
  description: 'A navigation bar with items added after it is initially rendered',
  reactWrapper_v3: {
    parentJSX: `Example = () => {
  const [items, setItems] = React.useState([{name: "sales", icon: "LineChartSolid", text: "Sales"}])
  return (
    <>
      <div style={{marginBottom: "10px"}}>
        <Tag3SimpleButton id="Add" accent="atoll" onButtonClick={() => setItems(itms => itms.concat({icon: "Tick", name: "done" + itms.length, text: "Done"}))}>Add item</Tag3SimpleButton>
        <Tag3SimpleButton id="remove" accent="atoll" disabled={items.length <= 1} onButtonClick={() => setItems(itms => itms.filter(i => i.name !== "done" + (items.length - 1)))} style={{marginLeft: "10px"}}>Remove  item</Tag3SimpleButton>
      </div>
      <Tag3SideNav accent="white">
        <Tag3SideNavHeader>
          MY SIMPLE APP
        </Tag3SideNavHeader>
        <Tag3SideNavBody>
          <Tag3SideNavPanel icon="Bullets" heading="Items" collapsable defaultExpanded>
            <div slot="nav-expanded">
              {items.map(item => <Tag3SideNavItem key={item.name} name={item.name} icon={item.icon} text={item.text} />)}
            </div>
          </Tag3SideNavPanel>
        </Tag3SideNavBody>
      </Tag3SideNav>
    </>
  )
}
`,
    jsx: '<Example />',
  },
};

const CollapsedStory: Story = {
  title: 'Programmatically collapsing',
  description: 'Setting whether the side bar is collapsed programmatically',
  coreComponent_v3: {
    html: `<tag3-side-nav collapsable{{...knobs}}>
  <tag3-side-nav-header>
    MY SIMPLE APP
  </tag3-side-nav-header>
  <tag3-side-nav-body>
    <tag3-side-nav-item name="sales" icon="LineChartSolid" text="Sales">
    </tag3-side-nav-item>
    <tag3-side-nav-item name="purchasing" icon="Pound1" text="Purchasing">
    </tag3-side-nav-item>
    <tag3-side-nav-item name="stock" icon="Stock" text="Stock">
    </tag3-side-nav-item>
  </tag3-side-nav-body>
</tag3-side-nav>`,
    knobs: {
      collapsed: {
        default: true,
        editor: 'checkbox',
      },
    },
  },
  reactWrapper_v3: {
    jsx: `<Tag3SideNav collapsable{{...knobs}}>
    <Tag3SideNavHeader>
      MY SIMPLE APP
    </Tag3SideNavHeader>
    <Tag3SideNavBody>
      <Tag3SideNavItem name="sales" icon="LineChartSolid" text="Sales">
      </Tag3SideNavItem>
      <Tag3SideNavItem name="purchasing" icon="Pound1" text="Purchasing">
      </Tag3SideNavItem>
      <Tag3SideNavItem name="stock" icon="Stock" text="Stock">
      </Tag3SideNavItem>
    </Tag3SideNavBody>
  </Tag3SideNav>`,
    knobs: {
      collapsed: {
        default: true,
        editor: 'checkbox',
      },
    },
  },
};

export const TagSideNavPanelDocs: Component = {
  type: 'component',
  name: 'side-nav-panel',
  description: `Panel element in the side navigation component`,
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'heading',
      description: 'Heading text for the panel',
      type: 'string',
    },
    {
      name: 'collapsable',
      description: 'Whether the panel can be collapsed',
      default: 'false',
      type: 'boolean',
    },
    {
      name: 'defaultExpanded',
      description: 'Whether the panel is expanded by default',
      default: 'false',
      type: 'boolean',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [],
};

export const TagSideNavItemDocs: Component = {
  type: 'component',
  name: 'side-nav-item',
  description: `Item element in the side navigation component`,
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'name',
      description: 'Name for the item',
      type: 'string',
    },
    {
      name: 'text',
      description: 'Text for the item',
      type: 'string',
    },
    {
      name: 'icon',
      description: 'Icon for the item',
      type: 'string',
    },
    {
      name: 'indent',
      description: 'The amount the item is indented',
      type: 'number',
    },
    {
      name: 'collapsable',
      description: 'Whether the item can be collapsed',
      default: 'false',
      type: 'boolean',
    },
    {
      name: 'defaultExpanded',
      description: 'Whether the item is expanded by default',
      default: 'false',
      type: 'boolean',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [],
};

export const TagSideNavDocs: Component = {
  type: 'component',
  name: 'side-nav',
  description: 'Renders a left navigation component',
  mobileFriendly: false,
  popular: false,
  preRelease: 'beta',
  props: [
    {
      name: 'collapsable',
      description: 'Whether the nav can be collapsed',
      default: 'false',
      type: 'boolean',
    },
    {
      name: 'collapsed',
      description: 'Whether the nav is collapsed',
      default: 'false',
      type: 'boolean',
    },
    {
      name: 'accent',
      description: 'Background colour of the nav',
      default: 'navy',
      type: '"navy" | "white"',
    },
    {
      name: 'selectedItem',
      description: 'Name of the selected item',
      default: '',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'sideNavItemSelected',
      description: 'Raised when an item is selected',
      parameters: [
        { name: 'name', description: 'name of the item selected', type: 'string' },
        { name: 'text', description: 'text of the item selected', type: 'string' },
      ],
    },
    {
      name: 'sideNavCollapsedChange',
      description: 'Raised when the nav is expanded and collasped',
      parameters: [
        { name: 'collapsed', description: 'Whether the nav is expanded', type: 'boolean' },
      ],
    },
    {
      name: 'sideNavItemCollapsedChange',
      description: 'Raised when a nav item is expanded and collasped',
      parameters: [
        {
          name: 'collapsed',
          description: 'Whether the item is expanded / collasped',
          type: 'boolean',
        },
        { name: 'name', description: 'name of the item expanded / collasped', type: 'string' },
        { name: 'text', description: 'text of the item expanded / collasped', type: 'string' },
      ],
    },
  ],
  methods: [],
  stories: [
    HierarchicalStory,
    SingleLevelStory,
    CollapsablePanelStory,
    CustomHeaderStory,
    CustomItemsStory,
    CustomPanelStory,
    SelectedItemStory,
    DynamicItemsStory,
    CollapsedStory,
  ],
  childComponents: [TagSideNavPanelDocs, TagSideNavItemDocs],
};
